import { render, staticRenderFns } from "./Applewatch.vue?vue&type=template&id=1b500880&"
import script from "./Applewatch.vue?vue&type=script&lang=js&"
export * from "./Applewatch.vue?vue&type=script&lang=js&"
import style0 from "./Applewatch.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
